<header>
  @if(business !== undefined) {
  <div class="tw-w-full tw-px-4 tw-flex tw-items-center tw-gap-4">
    @if(user && !isDesktop){
    <ul class="nav-container tw-flex-grow tw-items-center tw-justify-between">
      <li routerLink="/">
        <i class="pi pi-home mb-1"></i>
        <span>Home</span>
      </li>
      <li routerLink="/order">
        <i class="pi pi-list mb-1"></i>
        <span>Orders</span>
      </li>
      <li routerLink="/rewards">
        <i class="pi pi-gift mb-1"></i>
        <span>Rewards</span>
      </li>
      @if(user) {
        <li>
          <brt-user-notification />
        </li>
      }
      @if(!!business) {
      <li>
        <brt-user-status></brt-user-status>
      </li>
      }
    </ul>
    } @else {
    <div class="logo">
      <a routerLink="/" class="tw-flex tw-items-center tw-gap-2">
        <!-- TODO: show business logo if business is loaded -->
        <div class="tw-w-10 tw-flex tw-items-center tw-overflow-hidden">
          @if(business) {
          @if(business?.UI?.Logo) {
          <img [src]="business?.UI?.Logo" [alt]="business.UI?.Title"
            class="tw-max-w-full tw-max-h-full tw-object-contain tw-rounded-md" />
          }
          } @else if(hq?.UI?.Logo) {
          <img [src]="hq.UI.Logo" [alt]="hq.UI?.Title || hq.Name"
            class="tw-max-w-full tw-max-h-full tw-object-contain tw-rounded-md" />
          } @else {
          <img src="assets/images/logo/briteat-logo.svg" alt="logo" class="tw-scale-150 tw-max-w-full tw-max-h-full" />
          }
        </div>
        <h1 class="tw-text-xl lg:tw-text-3xl tw-leading-none">{{business ? business.UI?.Title : (hq ? (hq.UI?.Title || hq.Name) : 'Brit Eat')}}</h1>
      </a>
    </div>
    <div class="tw-flex-grow"></div>
    <brt-user-status></brt-user-status>
    @if(user) {
      <brt-user-notification />
    }
    }
    <brt-header-menu></brt-header-menu>
  </div>
  }

  <brt-pending-order-badge></brt-pending-order-badge>

</header>
<!-- <brt-current-location [add]="true"></brt-current-location> -->
<!-- <brt-current-orders></brt-current-orders> -->